import { Button, Stack, Text } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const NoDataTip = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="h-full flex justify-center items-center -mt-20">
      <Stack align="center">
        <IconRobot size={100} strokeWidth={1} />
        <Text size="lg" fw={700}>
          {t('access.nodata.title')}
        </Text>
        <Text ta="center" size="sm" color="gray.5">
          {t('access.nodata.desc')}
        </Text>
        <Button className="mt-5" onClick={() => navigate('/create')}>
          {t('access.nodata.btn')}
        </Button>
      </Stack>
    </div>
  );
};
